import { FirestoreEntity, IsoTimestamp, TimestampDto, StorageFolder } from '../../..';

export enum AlbumStatus {
  Active = 'active',
  Archived = 'archived',
}

export interface AlbumLocation {
  address?: string;
  geohash: string;
  latitude: number;
  longitude: number;
}

export interface AlbumEntityV0<Time extends TimestampDto = IsoTimestamp> {
  _version: 0;
  availableToDomainUsers: boolean;
  createdAt: Time;
  createdBy?: string;
  description?: string;
  folder: StorageFolder;
  groups?: string[];
  internalId?: string;
  isPublic?: boolean;
  isUserDefaultAlbum?: boolean;
  location?: AlbumLocation;
  name: string;
  /** Hash of the user provided password */
  publicPasswordHash?: string;
  systemStatus?: AlbumStatus;
  teamId: string;
  users: string[];
}

export type AlbumEntity<Time extends TimestampDto = IsoTimestamp> = AlbumEntityV0<Time>;
export type AnyAlbumEntityVersion = AlbumEntityV0<IsoTimestamp>; // TODO use union: `| v1 | v2 | v3`
export type AlbumDto = FirestoreEntity<AlbumEntity<TimestampDto>>;
